import { defineComponent as _defineComponent } from 'vue'
import HoldConversions from "@/components_v3/affiliate-balance/hold/ui/HoldConversions.vue";
import HoldFilters from "@/components_v3/affiliate-balance/hold/ui/HoldFilters.vue";
import PageLayout from "@/components_v3/layout/PageLayout.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HoldSingle',
  setup(__props) {


return { __sfc: true,HoldConversions, HoldFilters, PageLayout }
}

})